import { CourseAdminCard } from '@/components/shared/CourseAdminCard';
import { Assessment } from '@/models/Assessment';
import {
  CardDragglableProps,
  CardStaticProps,
} from '../shared/CourseAdminCard/types';

type AssessmentCardProps = {
  assessment: Assessment;
  onEdit?: (assessmentId: number) => void;
  onDelete?: (assessmentId: number) => void | Promise<unknown>;
  className?: string;
  isDeleting?: boolean;
} & (CardStaticProps | CardDragglableProps);

export default function AssessmentCard({
  assessment,
  onEdit,
  onDelete,
  ...treeCardProps
}: AssessmentCardProps) {
  return (
    <CourseAdminCard {...treeCardProps}>
      <CourseAdminCard.Header>
        <CourseAdminCard.Leading>
          <CourseAdminCard.Order value={assessment.order} />
          <CourseAdminCard.TitleBlock>
            <CourseAdminCard.Title>{assessment.name}</CourseAdminCard.Title>
            {assessment.description && (
              <CourseAdminCard.Description>
                {assessment.description}
              </CourseAdminCard.Description>
            )}
          </CourseAdminCard.TitleBlock>
        </CourseAdminCard.Leading>
        <CourseAdminCard.Actions>
          {onEdit && (
            <CourseAdminCard.EditButton onClick={() => onEdit(assessment.id)} />
          )}
          {onDelete && (
            <CourseAdminCard.MoreActions>
              <CourseAdminCard.MoreActions.Delete
                onClick={() => onDelete(assessment.id)}
                confirm
              />
            </CourseAdminCard.MoreActions>
          )}
        </CourseAdminCard.Actions>
      </CourseAdminCard.Header>
    </CourseAdminCard>
  );
}
